import { Core } from "@faire/design-tokens";
import { getSpacing } from "@faire/web/slate/spacing";
import styled from "styled-components";

export const ProductError = styled.div`
  background-color: red;
  text-align: center;
  color: ${Core.text.default};
`;

export const ImageContainer = styled.div`
  position: relative;
`;

export const RetailInfoContainer = styled.div`
  flex: 1;
  padding: ${getSpacing(0, 0, "1x", 0)};
`;

export const NotifyMeWrapper = styled.div`
  position: absolute;
  bottom: 8px;
  right: 8px;
  z-index: 5;
`;
